import api from '@/services/api';

const interceptors = store => {
  api.interceptors.request.use(
    (config) => {
      const token = store.getters['auth/token'];
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default interceptors;
